import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMessage/DislikeReasonPopover.tsx
import { useEffect, useId, useLayoutEffect, useRef, useState } from "react";
import { MdCheck } from "react-icons/md";
import { MESSAGE_FEEDBACK_REASONS } from "../../../domain/index.mjs";
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
import { Button, Popover, PopoverAnchor, PopoverContent, Text } from "../../primitive/index.mjs";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var DISLIKE_REASON_THANKS_MS = 1500;
function DislikeReasonPopover({ message, anchorRef, container, onPick, onClose }) {
  const { t } = useComponentsTranslation();
  const titleId = useId();
  const [picked, setPicked] = useState(null);
  const [saved, setSaved] = useState(false);
  const [open, setOpen] = useState(true);
  const pressedOutsideRef = useRef(false);
  const contentRef = useRef(null);
  const [boundary] = useState(() => anchorRef.current?.closest(".buyscout-chat-log") ?? void 0);
  useLayoutEffect(() => {
    const closeOnPressOutside = (event) => {
      if (contentRef.current && event.composedPath().includes(contentRef.current)) return;
      pressedOutsideRef.current = true;
      setOpen(false);
    };
    document.addEventListener("pointerdown", closeOnPressOutside);
    return () => document.removeEventListener("pointerdown", closeOnPressOutside);
  }, []);
  useEffect(() => {
    if (!saved) return;
    const timer = window.setTimeout(setOpen, DISLIKE_REASON_THANKS_MS, false);
    return () => window.clearTimeout(timer);
  }, [saved]);
  const pick = (reason) => {
    if (picked) return;
    setPicked(reason);
    Promise.resolve().then(() => onPick(message, reason)).then(() => setSaved(true), () => setPicked(null));
  };
  return /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx(PopoverAnchor, { virtualRef: anchorRef }),
    /* @__PURE__ */ jsxs(
      PopoverContent,
      {
        ref: contentRef,
        container,
        side: "top",
        align: "start",
        collisionBoundary: boundary,
        sticky: "always",
        tip: true,
        sideOffset: 4,
        arrowPadding: 16,
        alignOffset: -20,
        "aria-labelledby": saved ? void 0 : titleId,
        "aria-label": saved ? t("chatMessage.dislikeReasonThanks") : void 0,
        "aria-busy": picked != null && !saved || void 0,
        className: "buyscout-chat-message-dislike-reason",
        onInteractOutside: () => {
          pressedOutsideRef.current = true;
        },
        onCloseAutoFocus: (event) => {
          event.preventDefault();
          if (!pressedOutsideRef.current) anchorRef.current?.focus();
          onClose();
        },
        children: [
          !saved && /* @__PURE__ */ jsx(Text, { id: titleId, variant: "body-sm", as: "span", className: "buyscout-chat-message-dislike-reason__title", children: t("chatMessage.dislikeReasonTitle") }),
          !saved && /* @__PURE__ */ jsx("div", { className: "buyscout-chat-message-dislike-reason__chips", children: MESSAGE_FEEDBACK_REASONS.map((reason) => /* @__PURE__ */ jsx(Button, { variant: "bordered", color: "neutral", shape: "pill", size: "xs", "aria-pressed": picked === reason, onClick: () => pick(reason), children: t(`chatMessage.dislikeReasons.${reason}`) }, reason)) }),
          /* @__PURE__ */ jsx(Text, { variant: "body-sm", as: "p", role: "status", className: "buyscout-chat-message-dislike-reason__thanks", children: saved && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(MdCheck, { "aria-hidden": true, className: "buyscout-chat-message-dislike-reason__check" }),
            t("chatMessage.dislikeReasonThanks")
          ] }) })
        ]
      }
    )
  ] });
}
DislikeReasonPopover.displayName = "DislikeReasonPopover";
export {
  DislikeReasonPopover
};
//# sourceMappingURL=DislikeReasonPopover.mjs.map